export default {
    data() {
        return {
            redirect: "",
            loading: false, // 请求中
            isModal: false // 是否是对话框，是——》不进行路由跳转
        };
    },
    watch: {
        $route: {
            handler(to) {
                // 获取非同一域名下的路由重定向地址，不直接使用 $route.query.redirect 为了兼容redirect链接中有query参数
                const redirectIndex = to.fullPath.indexOf("redirect=");
                if (redirectIndex !== -1) {
                    this.redirect = to.fullPath.slice(redirectIndex + 9);
                }
            },
            immediate: true
        }
    },
    methods: {
        async login(type, account, credential, callback) {
            this.loading = true;
            try {
                // const res = await this.$api.auth.login(type, account, credential);
                const param = {
                    loginName: account,
                    loginType: type, //email password phoneNumber
                    password: credential,
                    productName: "vsp",
                    sessionId: "",
                    verifyCode: credential
                };
                const res = await this.$api.auth.Login(param);
                // 登录失败
                if (res.errCode !== 0) {
                    this.$Message.error(res.errMsg);
                    this.loading = false;
                    return;
                }
                // 设置登录状态
                if (res.data) {
                    // ******记录登录状态******
                    this.$store.commit("SET_TOKEN", res.data);
                    // ******获取用户信息******
                    await this.$store.dispatch("getUserInfo", JSON.stringify(res.data));
                    this.$Message.success("登录成功");
                    // this.$api.eduyun.RegisterUser();
                    if (this.isModal) {
                        this.$emit("login-success");
                        this.loading = false;
                        this.$router.go(0);
                        return;
                    }
                    // ******页面登录 回跳地址******
                    if (this.redirect) {
                        // 非当前域名地址重定向，登录页面不保存在历史中，防止其他页面点返回按钮跳到登录页
                        document.location.replace(decodeURIComponent(this.redirect));
                    } else {
                        let type = localStorage.getItem("type")
                        //老师
                        if (type == 1) {
                            this.$router.push({ path: "/experimentList" });
                        } else {
                            //学生
                            this.$router.push({ path: "/experimentalCenter" });
                        }
                    }
                }
                this.loading = false;
            } catch {
                this.loading = false;
            }
        },
    }
};